import React, { FC } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import imagePng from "images/hero-left-home.png";
import HeroSearchForm from "components/HeroSearchForm/HeroSearchForm";

export interface SectionHeroProps {
  className?: string;
}

const SectionHero: FC<SectionHeroProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-SectionHero flex flex-col-reverse lg:flex-col relative ${className}`}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col lg:flex-row lg:items-center">
        <div className="flex flex-col items-start flex-shrink-0 space-y-8 lg:w-1/2 sm:space-y-10 pb-14 lg:pb-64 xl:pr-14 lg:mr-10 xl:mr-0">
          <h2 className="font-bold text-4xl md:text-5xl xl:text-5xl !leading-[150%]">
            برای ماجراجویی و تجربه یک سفر متفاوت آماده‌ای؟
          </h2>
          <span className="hidden text-base md:text-lg text-neutral-500 dark:text-neutral-400 sm:block">
            جادونی جاییه که لحظات میتونن به خاطرات شیرین تبدیل بشن. تورهای
            رویایی بومگردی و لذت بردن از یک ماجراجویی خیلی خاص، یا لذت اقامت در
            یک اقامتگاه خاص و ویژه که خستگی زندگی روزمره رو از تنت بیرون میکنه.
            با یک کلیک آخرین تورهای محبوب بومگردی رو بررسی کن و همراه ما به
            دنیایی از سفر و ماجراجویی قدم بزار و یک سفر پر از خاطره شیرین رو
            آغاز کن!
          </span>
          <ButtonPrimary className="hidden bg-emerald-600 sm:block">
            مشاهده آخرین تورهای ویژه
          </ButtonPrimary>
        </div>

        <div className="flex-grow">
          <img className="w-full" src={imagePng} alt="hero" />
        </div>
      </div>

      <div className="z-10 hidden w-full mb-12 lg:block lg:mb-0 lg:-mt-40">
        <HeroSearchForm />
      </div>
    </div>
  );
};

export default SectionHero;
